import InnerImageZoom from './InnerImageZoom';
export default InnerImageZoom;
export { InnerImageZoom };
